/**
 * @format
 */

import { enqueueNotification } from '../../app';
import request from '../../../helpers/request';
import {
  GET_LIST_VIEWER_FAILURE,
  GET_LIST_VIEWER_REQUEST,
  GET_LIST_VIEWER_SUCCESS,
} from '../actions';

export default (list_id, workspace_id) => {
  return async dispatch => {
    dispatch({ type: GET_LIST_VIEWER_REQUEST, payload: list_id });

    try {
      const { data } = await request.get(
        `/api/pipeline/lists/v1/${workspace_id}/${list_id}/share`,
        {},
        dispatch
      );
      if (data.success) {
        localStorage.setItem(
          'listViewersLength',
          data.data === 'all' ? 1 : data.data.length
        );
        dispatch({
          type: GET_LIST_VIEWER_SUCCESS,
          payload: {
            listViewers: data.data,
            list_id,
          },
        });
        return Promise.resolve(data);
      } else {
        const message = data.message;
        dispatch({
          type: GET_LIST_VIEWER_FAILURE,
          payload: message,
        });
        dispatch(enqueueNotification(message));
        return Promise.reject(new Error(message));
      }
    } catch (err) {
      const message =
        'Something went wrong while laoding list viewers, please try again.';
      dispatch({
        type: GET_LIST_VIEWER_FAILURE,
        payload: message,
      });
      dispatch(enqueueNotification(message));
      return Promise.reject(err);
    }
  };
};
